import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

/**
 * Shared logic for Date Formatting in the system (DD/MM/YYYY)
 */
const DELIMITER = '/';

function parseDate(value: string | null): NgbDateStruct | null {
  if (!value) return null;
  const parts = value.split(DELIMITER);
  return {
    day: Number(parts[0]),
    month: Number(parts[1]),
    year: Number(parts[2]),
  };
}

function formatDate(date: NgbDateStruct | null): string {
  if (!date) return '';
  const day = date.day <= 9 ? `0${date.day}` : date.day;
  const month = date.month <= 9 ? `0${date.month}` : date.month;
  return `${day}${DELIMITER}${month}${DELIMITER}${date.year}`;
}

/**
 * Adapter handles Model <-> Internal format
 */
@Injectable()
export class SSDateAdapter extends NgbDateAdapter<string> {
  fromModel(value: string | null): NgbDateStruct | null {
    return parseDate(value);
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date ? formatDate(date) : null;
  }
}

/**
 * ParserFormatter handles UI <-> Internal format
 */
@Injectable()
export class SSDateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    return parseDate(value);
  }

  format(date: NgbDateStruct | null): string {
    return formatDate(date);
  }
}
